// extracted by mini-css-extract-plugin
module.exports = {"particlesJs":"Particles_particlesJs__2BjYq"};